// extracted by mini-css-extract-plugin
export default {"Checkmark":"styles_Checkmark__yxKxf","checkmark":"styles_checkmark__-dZ99","checked":"styles_checked__5fTFc"};